import { enumEstadoTurno } from '../../../utils/constants/estadoTurno.constants';
import { formatDate } from '../../../utils/helpers/date.helpers';
import { useAuthContext } from "../../../context/auth";
import Contenedor from '../../../components/generalStructure/Contenedor/Contenedor';
import { useNavigate } from 'react-router-dom';

import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import { useEffect, useState } from 'react';
import { useTurnos } from '../../../services/useTurnos.service';
import 'react-vertical-timeline-component/style.min.css';

const ContenedorMisTurnos = () => {

    const navigate = useNavigate();
    const { afiliado } = useAuthContext();
    const [ service, error, loading ] = useTurnos();
    const [ listaTurnos, setListaTurnos ] = useState([]);

    useEffect(() => {

        if(!afiliado) return;

        service.getByDni(
            afiliado.dni,
            (turnos) => {
                //console.log("turnos", turnos);
                setListaTurnos(turnos)
            }
        );

    }, [afiliado]); //eslint-disable-line

    return (

        <Contenedor
            titulo="Mis turnos"
            className="my-3"
        >

            {
                loading && 
                <p>Cargando...</p>
            }

            {
                error && 
                <p>Hubo un error al cargar la lista</p>
            }

            {
                listaTurnos && listaTurnos.length > 0 &&
                <VerticalTimeline>
                    {   
                        [...listaTurnos]
                            .sort((a, b) => new Date(b.fechaCalendario.fecha) - new Date(a.fechaCalendario.fecha))
                            .map(turno => <VerticalTimelineElement
                                key={turno.id}
                                className="vertical-timeline-element--work"
                                contentStyle={{ background: turno.estadoTurnoID === enumEstadoTurno.ANULADO.id ? '#e86971': '#76bb7f', color: '#fff', cursor: "pointer" }}
                                contentArrowStyle={{ borderRight: `7px solid  ${turno.estadoTurnoID === enumEstadoTurno.ANULADO.id ? '#e86971': '#76bb7f'}` }}
                                date={formatDate(turno.fechaCalendario.fecha) + " - " + turno.estadoTurno.descripcion}
                                dateClassName={turno.estadoTurnoID === enumEstadoTurno.ANULADO.id ? 'text-danger' : 'text-success'}
                                onTimelineElementClick={e=> navigate("/Turno/" + turno.id)}
                                iconStyle={{ background: turno.estadoTurnoID === enumEstadoTurno.ANULADO.id ? '#e86971': '#76bb7f', color: '#fff' }}
                            >
                                <h3
                                    className="vertical-timeline-element-title">{turno.fechaCalendario.centroRecreativo.descripcion}
                                </h3>
                            </VerticalTimelineElement>
                        )
                    }

                </VerticalTimeline> 
            }
        </Contenedor>
    )
};

export default ContenedorMisTurnos;